import { render, staticRenderFns } from "./TCard.vue?vue&type=template&id=02b4a6a2&"
import script from "./TCard.vue?vue&type=script&lang=js&"
export * from "./TCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02b4a6a2')) {
      api.createRecord('02b4a6a2', component.options)
    } else {
      api.reload('02b4a6a2', component.options)
    }
    module.hot.accept("./TCard.vue?vue&type=template&id=02b4a6a2&", function () {
      api.rerender('02b4a6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/TCard.vue"
export default component.exports